import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetMunicipalities_municipalityIdExportsCsv = z.any()
export type TagsGetMunicipalities_municipalityIdExportsCsv = z.infer<typeof tagsGetMunicipalities_municipalityIdExportsCsv>

export const descriptionGetMunicipalities_municipalityIdExportsCsv = z.any()
export type DescriptionGetMunicipalities_municipalityIdExportsCsv = z.infer<typeof descriptionGetMunicipalities_municipalityIdExportsCsv>

export const paramsGetMunicipalities_municipalityIdExportsCsv = z.object({ "municipalityId": z.string().uuid() })
export type ParamsGetMunicipalities_municipalityIdExportsCsv = z.infer<typeof paramsGetMunicipalities_municipalityIdExportsCsv>

export const querystringGetMunicipalities_municipalityIdExportsCsv = z.object({ "from": z.string().date().optional(), "to": z.string().date().optional(), "packaging": z.union([z.literal("single"), z.literal("zip")]).default("single"), "grain": z.union([z.literal("raw"), z.literal("quarterHour"), z.literal("hour"), z.literal("day"), z.literal("month"), z.literal("year")]).default("raw") }).strict()
export type QuerystringGetMunicipalities_municipalityIdExportsCsv = z.infer<typeof querystringGetMunicipalities_municipalityIdExportsCsv>

export const responseGetMunicipalities_municipalityIdExportsCsv = z.any()
export type ResponseGetMunicipalities_municipalityIdExportsCsv = z.infer<typeof responseGetMunicipalities_municipalityIdExportsCsv>

interface IGetMunicipalities_municipalityIdExportsCsv extends BaseMethodType {
  tags: TagsGetMunicipalities_municipalityIdExportsCsv,
  description: DescriptionGetMunicipalities_municipalityIdExportsCsv,
  params: ParamsGetMunicipalities_municipalityIdExportsCsv,
  querystring: QuerystringGetMunicipalities_municipalityIdExportsCsv,
  response: ResponseGetMunicipalities_municipalityIdExportsCsv
}
export const URL = '/municipalities/:municipalityId/exports/csv'
export const validation = {
  get: {
    tags: tagsGetMunicipalities_municipalityIdExportsCsv,
    description: descriptionGetMunicipalities_municipalityIdExportsCsv,
    params: paramsGetMunicipalities_municipalityIdExportsCsv,
    querystring: querystringGetMunicipalities_municipalityIdExportsCsv,
    response: responseGetMunicipalities_municipalityIdExportsCsv
  }
}
export interface Municipalities_municipalityIdExportsCsv extends BaseRouteType {
  get: IGetMunicipalities_municipalityIdExportsCsv
}